

// Lazy-loaded components for code splitting
const CodeDocumentTypeList = () => import(/* webpackChunkName: "code-document-type" */ "./pages/ListPage.vue");
const CodeDocumentTypeDetail = () => import(/* webpackChunkName: "code-document-type" */ "./pages/FormPage.vue");
const CodeDocumentTypeIndex = () => import(/* webpackChunkName: "code-document-type" */ "./pages/IndexPage.vue");
export default [
  {
    path: "/code_document_type",
    component: CodeDocumentTypeIndex,
    redirect: "/code_document_type/list",
    name: "code_document_type",
    children: [
      {
        path: "list",
        component: CodeDocumentTypeList,
        name: "code_document_type.list",
      },
      {
        path: "create",
        component: CodeDocumentTypeDetail,
        name: "code_document_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeDocumentTypeDetail,
        name: "code_document_type.edit",
        props: { create: false },
      },
    ],
  },
];
